import { salesforceEnvLightningURL } from '../salesforce/url';

export function getSalesforceHouseholdLink(salesforceAccountId: string) {
  return `${salesforceEnvLightningURL()}/lightning/r/Account/${salesforceAccountId}/view`;
}

export function getOrionHouseholdLink(orionHouseHoldId: string) {
  return `https://api.cloud.orionadvisor.com/orionconnectapp/#/orion/dashboard?entity=5&entityId=${orionHouseHoldId}`;
}
